<template lang="pug">
  .the-b2b-profile-signature
    ods-form(
      ref='signatureForm',
      :model='signatureForm',
      :rules='validationRules')
      ods-module
        div.border
          ods-row(type='flex')
            ods-col(:span='24')
              ods-form-item.title(
                :label='$t("profile.signature.presentation_title")')
          ods-row(type='flex')
            ods-col(:span='24')
              ods-input.text(v-model='inputModel', :readonly='true', type='textarea')
          ods-row(type='flex')
            ods-col(:span='24')
              ods-form-item.title.last(
                :label='$t("profile.signature.instructions_title")')
          ods-row(type='flex')
            ods-col(:span='24')
              div(align='left', style='width: 100%; margin-bottom: 15px;')
                .ods-form-item__content.sign
                  p {{ $t('profile.signature.instructions_text1') }}
                  p {{ $t('profile.signature.instructions_text2') }}
                    a(:href='$t("profile.signature.instructions_text2_dir")' target="_blank")
                      | {{$t('profile.signature.instructions_text2_link')}}
                  p {{ $t('profile.signature.instructions_text3') }}
                  p {{ $t('profile.signature.instructions_text4') }}
            //ods-col(:span='24')
              //ods-input.maximizeHeight(v-model='inputModel2', :readonly='true', type='textarea')
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("profile.signature.taxIdentificationNumber.label")'
              prop='taxIdentificationNumber')
              ods-select(
                  :no-match-text='$t("msg_generics.no_match")',
                  v-model='userPartySelect.taxIdentificationNumber',
                  filterable,
                  :filter-method='filterPartiesSignature',
                  :placeholder='$t("profile.signature.profile_signature_form.valueNif.placeholder")',
                  @change='changeSelectParty')
                  ods-option(
                      v-for='userParty in userParties',
                      :key='userParty.taxIdentificationNumber',
                      :label='userParty.taxIdentificationNumber',
                      :value='userParty.taxIdentificationNumber')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("profile.signature.corporateName.label")'
              prop='corporateName')
              ods-input(v-model='signatureForm.corporateName')
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("profile.signature.address.label")'
              prop='address')
              ods-input(v-model='signatureForm.address')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("profile.signature.town.label")'
              prop='town')
              ods-input(v-model='signatureForm.town')
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("profile.signature.postcode.label")'
              prop='postcode')
              ods-input(v-model='signatureForm.postcode')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("profile.signature.province.label")'
              prop='province')
              ods-input(v-model='signatureForm.province')
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("profile.signature.countryName.label")'
              prop='countryName')
              ods-select(
                v-model='signatureForm.countryName',
                filterable,
                :placeholder='$t("party_detail.party_detail_edit_form.country.placeholder")')
                ods-option(
                  v-for='option in countries',
                  :key='option.id',
                  :label='$t("countries.country_" + option.codeAlfa3)',
                  :value='option.name')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("profile.signature.countryNameUser.label")'
              prop='countryNameUser')
              ods-select(
                v-model='signatureForm.countryNameUser',
                filterable,
                :placeholder='$t("party_detail.party_detail_edit_form.country.placeholder")')
                ods-option(
                  v-for='option in countries',
                  :key='option.id',
                  :label='$t("countries.country_" + option.codeAlfa3)',
                  :value='option.name')
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("profile.signature.name.label")'
              prop='nombre')
              ods-input(v-model='signatureForm.nombre')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("profile.signature.first_surname.label")'
              prop='apellido1')
              ods-input(v-model='signatureForm.apellido1')
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("profile.signature.second_surname.label")'
              prop='apellido2')
              ods-input(v-model='signatureForm.apellido2')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("profile.signature.dni.label")'
              prop='dni')
              ods-input(v-model='signatureForm.dni' :placeholder='$t("profile.signature.dni.placeholder")')
        ods-row(type='flex')
          ods-col(:span='10')

            ods-form-item(
              :label='$t("profile.signature.cargoFirmante.label")'
              prop='cargoFirmante')
              ods-select(
                  :no-match-text='$t("msg_generics.no_match")',
                  v-model='signatureForm.cargoFirmante',
                  :placeholder='$t("profile.signature.profile_signature_form.cargoFir.placeholder")')
                  ods-option(
                      v-for='cargo in cargoFirman',
                      :key='cargo.nombre',
                      :label='$t("profile.signature.cFirman."+ cargo.nombre)',
                      :value='cargo.nombre')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("profile.signature.poblacionFirma.label")'
              prop='poblacionFirma')
              ods-input(v-model='signatureForm.poblacionFirma')
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("profile.signature.resolucion.label")'
              prop='resolucion')
              ods-input(v-model='signatureForm.resolucion'
              @change='resolucionIsEmply'
              :placeholder='$t("profile.signature.profile_signature_form.resolucion.placeholder")')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("profile.signature.fecha.label")',
              prop='fecha')
                ods-date-picker(
                v-model='signatureForm.fecha',
                :disabled='showDate',
                type='date',
                prefix-icon='prefix-icon-date-time-picker',
                :placeholder='$t("msg_generics.date")')
        ods-row(type='flex')
          ods-col(:span='10')
            ods-tooltip(:content='$t("invoice_detail.buttons.download_PDF")', placement='bottom')
              div
                ods-button(
                  type='primary',
                  icon='ods-icon-download',
                  size='small',
                  circle,
                  @click.native='downloadPDF("signatureForm")')
                  | {{ $t('invoice_detail.buttons.download_PDF') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-profile-signature',
  mixins: [Utils],
  data () {
    const self = this

    const checkDNI = (rule, value, callback) => {
      let countryNameUser = self.signatureForm.countryNameUser
      if (!countryNameUser) {
        countryNameUser = this.$t('countries.country_ESP')
      }
      if (countryNameUser === this.$t('countries.country_ESP')) {
        let numero, letr, letra
        const expresion_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/ // eslint-disable-line
        const dni = value.toUpperCase()

        if (expresion_regular_dni.test(dni) === true) {
          numero = dni.substr(0, dni.length - 1)
          numero = numero.replace('X', 0)
          numero = numero.replace('Y', 1)
          numero = numero.replace('Z', 2)
          letr = dni.substr(dni.length - 1, 1)
          numero = numero % 23
          letra = 'TRWAGMYFPDXBNJZSQVHLCKET'
          letra = letra.substring(numero, numero + 1)
          if (letra !== letr) {
            callback(new Error(this.$t('profile.signature.dniError')))
          } else {
            callback()
          }
        } else {
          callback(new Error(this.$t('profile.signature.dniError')))
        }
      } else {
        callback()
      }
    }
    return {
      inputModel: this.$t('profile.signature.presentation_text') + ' ' + this.$t('profile.signature.presentation_text2'),
      inputModel1: this.$t('profile.signature.instructions_text1'),
      inputModel2: this.$t('profile.signature.instructions_text1') + '\n' + this.$t('profile.signature.instructions_text2') + ' ' + this.$t('profile.signature.instructions_text2_link') + ' ' + this.$t('profile.signature.instructions_text2_dir') + '\n' +
        this.$t('profile.signature.instructions_text3') + '\n' + this.$t('profile.signature.instructions_text4'),
      showDate: true,
      tid: null,
      signatureForm: {
        taxIdentificationNumber: '',
        corporateName: '',
        address: '',
        town: '',
        postcode: '',
        province: '',
        countryName: '',
        countryNameUser: '',
        nombre: '',
        apellido1: '',
        apellido2: '',
        dni: '',
        cargoFirmante: '',
        poblacionFirma: '',
        resolucion: '',
        fechaDD: '',
        fechaMM: '',
        fechaAAAA: '',
        fecha: ''
      },
      cargoFirman: [
        {
          nombre: 'adm'
        },
        {
          nombre: 'apo'
        },
        {
          nombre: 'con'
        },
        {
          nombre: 'dir'
        },
        {
          nombre: 'ger'
        },
        {
          nombre: 'rep'
        },
        {
          nombre: 'tit'
        }
      ],
      userParties: [],
      userParty: {},
      userPartySelect: [],
      validationRules: {
        taxIdentificationNumber: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        corporateName: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        address: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        town: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        postcode: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        province: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        countryName: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        nombre: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        apellido1: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        apellido2: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        dni: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          },
          { validator: checkDNI, trigger: 'change' }
        ],
        cargoFirmante: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        poblacionFirma: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ]
      }
    }
  },

  computed: { ...mapGetters(['activeUser', 'canNoEditUserData', 'countries']) },

  methods: {
    ...mapActions([
      'getUserPartiesSignature',
      'optionsFilterSignature',
      'getUserPartiesSignaturePDF',
      'validarDNI'
    ]),

    async resolucionIsEmply () {
      if (this.signatureForm.resolucion === '') {
        this.showDate = true
      } else if (!this.signatureForm.resolucionIsEmply) {
        this.showDate = false
      }
    },

    async changeSelectParty (data) {
      const option = this.userParties.find(function (elem) {
        return elem.taxIdentificationNumber === data
      })
      this.signatureForm.taxIdentificationNumber = this.userPartySelect.taxIdentificationNumber
      this.signatureForm.corporateName = option.corporateName
      this.signatureForm.address = option.address
      this.signatureForm.town = option.town
      this.signatureForm.postcode = option.postcode
      this.signatureForm.province = option.province
      this.signatureForm.countryName = option.countryName
      this.signatureForm.countryNameUser = this.$t('countries.country_ESP')
    },
    async getPartiesResults (data) {
      const requestSignature = {
        taxIdentificationNumber: data
      }
      try {
        const response = await this.getUserPartiesSignature(requestSignature)
        this.userParties = response
      } catch (error) {
        console.log('filterPartiesBuyer CATCH: ', error)
        this.showNotificationError(error)
      }
    },
    async filterPartiesSignature (data) {
      try {
        // Si el valor introducido tiene exactamente 3 caracteres se obtiene la lista a través de servicio REST de empresas
        if (data.length >= 3) {
          clearTimeout(this.tid)
          this.tid = setTimeout(this.getPartiesResults, 1000, data)
        }
      } catch (error) {
        console.log('filterPartiesSignature CATCH: ', error)
        this.showNotificationError(error)
      }
    },

    async downloadPDF (formSignature) {
      this.$refs[formSignature].validate(async (valid) => {
        if (valid) {
          console.log('downloadPDF: ', this.signatureForm)
          const load = this.$loading({
            lock: true,
            text: this.$t('invoice_detail.load.download_attachment')
          })
          try {
            const params = this.signatureForm
            let dniOk = true
            if (this.signatureForm.countryNameUser === this.$t('countries.country_ESP')) {
              dniOk = await this.validarDNI(params)
            }
            if (dniOk) {
              const filename = await this.getUserPartiesSignaturePDF(params)
              this.$notify({
                title: this.$t('msg_generics.download_file_ok', { filename: filename }),
                type: 'success',
                position: 'top-right',
                customClass: 'b2b-notification-success',
                duration: 10000
              })
            } else {
              this.$notify({
                title: this.$t('profile.signature.dniError'),
                type: 'error',
                position: 'top-right',
                customClass: 'b2b-notification-error',
                duration: 10000
              })
            }
          } catch (error) {
            console.log('downloadPDF CATCH: ', error)
            this.showNotificationError(error)
          } finally {
            load.close()
          }
        } else {
          console.log('downloadPDF INVALID: ', this.signatureForm)
          return false
        }
      })
    }
  },
  created () {
    this.signatureForm.countryNameUser = this.$t('countries.country_ESP')
  }
}
</script>

<style lang="scss" scoped>
.the-b2b-profile-signature {
  margin: 3rem;
  ::v-deep .ods-module{
    &__header{
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info{
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body{
      padding: 32px;
      .info{
        padding-bottom: 32px;
      }
      ::v-deep .the-b2b-tags-component {
        &__group {
          padding: rem(0);
          margin-left: -rem(10);
          margin-right: -rem(10);
          .ods-button {
            padding-left: rem(0);
          }
        }
      }
      ::v-deep .border {
        border: #dad9d9 solid 0.5px;
        box-sizing: border-box;
        padding: 10px;
        margin-bottom: 20px;
        border-radius: 10px
      }
    }
  }

  .form-actions{
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button{
      float: right;
    }
  }
}
::v-deep.ods-form-item.title{
  margin: 2px 0px 2px 0px!important;
  padding: 0px!important;
}
::v-deep.ods-form-item.title.last {
    margin: 22px 0px 2px 0px!important;
  }

::v-deep .ods-form-item{
    line-height: 8px;
    margin-bottom: 15px;
}
::v-deep .ods-form-item__error{
  padding-top: 0px!important;
}
::v-deep .ods-form-item__label {
    float: none;
    display: inline-block;
    margin-bottom: 2px;
}
::v-deep .ods-col.ods-col-24, .text.ods-input, .text.ods-textarea{
  padding: 0px!important;
  margin: 0px 0px!important;
  display: flex;
  .maximizeHeight {
    .ods-textarea__inner {
      min-height: 100px!important;
    }
  }
  .ods-input__inner, .ods-textarea__inner{
    padding-left: 8px;
    min-height: 40px;
    font-style: italic;
  }

::v-deep .text.blue-text.ods-input
  .ods-input__inner{
    color: var(--color-bg-interactive);
    margin-left: -15px;
    text-decoration: underline;
  }
}
::v-deep .ods-form-item.title {
  .ods-form-item__label{
    font-size: 11px;
  }
}
::v-deep .ods-form-item__content.sign {
    background-color: var(--color-bg-hover-2) !important;
    padding: 8px;
    font-style: italic;
}
</style>
